import React from 'react'


const CreatorImage = props => {
    
    return<>
              <img src={props.info?.image} alt="avatar" className='avatar' />
            
     </>
}



export default CreatorImage;